import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mysticoracle/mysticoracle/src/app/components/WelcomeClient.tsx");
